import { createApiSaga } from '../../../sagaGenerator';
import {
  apiGet, apiPost, apiPut,
} from '../../../../middleware/api';
import {
  GET_EDIT_RUNUP_REQUEST,
  GET_EDIT_RUNUP_SUCCESS,
  GET_EDIT_RUNUP_FAILURE,
  UPDATE_EDIT_RUNUP_REQUEST,
  UPDATE_EDIT_RUNUP_SUCCESS,
  UPDATE_EDIT_RUNUP_FAILURE,
  CREATE_EDIT_RUNUP_REQUEST,
  CREATE_EDIT_RUNUP_SUCCESS,
  CREATE_EDIT_RUNUP_FAILURE,
  EDIT_RUNUP_TSUNAMI_REQUEST,
  EDIT_RUNUP_TSUNAMI_SUCCESS,
  EDIT_RUNUP_TSUNAMI_FAILURE,
  EDIT_RUNUP_TSUNAMI_SEARCH_REQUEST,
  EDIT_RUNUP_TSUNAMI_SEARCH_SUCCESS,
  EDIT_RUNUP_TSUNAMI_SEARCH_FAILURE,
  EDIT_RUNUP_REFERENCE_REQUEST,
  EDIT_RUNUP_REFERENCE_SUCCESS,
  EDIT_RUNUP_REFERENCE_FAILURE,
  EDIT_RUNUP_REFERENCE_SEARCH_REQUEST,
  EDIT_RUNUP_REFERENCE_SEARCH_SUCCESS,
  EDIT_RUNUP_REFERENCE_SEARCH_FAILURE,
  EDIT_RUNUP_REGION_REQUEST,
  EDIT_RUNUP_LOCATION_REQUEST,
  EDIT_RUNUP_FIRST_MOTION_REQUEST,
  EDIT_RUNUP_COUNTRY_REQUEST,
  EDIT_RUNUP_AREA_REQUEST,
  EDIT_RUNUP_FIRST_MOTION_FAILURE,
  EDIT_RUNUP_FIRST_MOTION_SUCCESS,
  EDIT_RUNUP_LOCATION_FAILURE,
  EDIT_RUNUP_LOCATION_SUCCESS,
  EDIT_RUNUP_AREA_FAILURE,
  EDIT_RUNUP_AREA_SUCCESS,
  EDIT_RUNUP_COUNTRY_FAILURE,
  EDIT_RUNUP_COUNTRY_SUCCESS,
  EDIT_RUNUP_REGION_FAILURE,
  EDIT_RUNUP_REGION_SUCCESS,
  EDIT_RUNUP_MEASUREMENT_TYPE_REQUEST,
  EDIT_RUNUP_MEASUREMENT_TYPE_FAILURE,
  EDIT_RUNUP_MEASUREMENT_TYPE_SUCCESS,
} from './runupEditReducer';


const getRunupSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/runups/${action.id}`, ...action }),
  requestType: GET_EDIT_RUNUP_REQUEST,
  successType: GET_EDIT_RUNUP_SUCCESS,
  failureType: GET_EDIT_RUNUP_FAILURE,
});

const createRunupSaga = createApiSaga({
  apiFunction: apiPost,
  generateApiConfig: action => ({ endpoint: '/tsunamis/runups', ...action }),
  requestType: CREATE_EDIT_RUNUP_REQUEST,
  successType: CREATE_EDIT_RUNUP_SUCCESS,
  failureType: CREATE_EDIT_RUNUP_FAILURE,
  successMessage: 'Saved',
});

const updateRunupSaga = createApiSaga({
  apiFunction: apiPut,
  generateApiConfig: action => ({ endpoint: `/tsunamis/runups/${action.id}`, ...action }),
  requestType: UPDATE_EDIT_RUNUP_REQUEST,
  successType: UPDATE_EDIT_RUNUP_SUCCESS,
  failureType: UPDATE_EDIT_RUNUP_FAILURE,
  successMessage: 'Saved',
});

const getTsunamiSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/runups/${action.id}/tsunami`, ...action }),
  requestType: EDIT_RUNUP_TSUNAMI_REQUEST,
  successType: EDIT_RUNUP_TSUNAMI_SUCCESS,
  failureType: EDIT_RUNUP_TSUNAMI_FAILURE,
});

const searchTsunamisSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/tsunamis/events', ...action }),
  requestType: EDIT_RUNUP_TSUNAMI_SEARCH_REQUEST,
  successType: EDIT_RUNUP_TSUNAMI_SEARCH_SUCCESS,
  failureType: EDIT_RUNUP_TSUNAMI_SEARCH_FAILURE,
});


const getReferencesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/runups/${action.id}/references`, ...action }),
  requestType: EDIT_RUNUP_REFERENCE_REQUEST,
  successType: EDIT_RUNUP_REFERENCE_SUCCESS,
  failureType: EDIT_RUNUP_REFERENCE_FAILURE,
});

const searchReferencesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/references', ...action }),
  requestType: EDIT_RUNUP_REFERENCE_SEARCH_REQUEST,
  successType: EDIT_RUNUP_REFERENCE_SEARCH_SUCCESS,
  failureType: EDIT_RUNUP_REFERENCE_SEARCH_FAILURE,
});


const getRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/regions', ...action }),
  requestType: EDIT_RUNUP_REGION_REQUEST,
  successType: EDIT_RUNUP_REGION_SUCCESS,
  failureType: EDIT_RUNUP_REGION_FAILURE,
});

const getCountriesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/countries', ...action }),
  requestType: EDIT_RUNUP_COUNTRY_REQUEST,
  successType: EDIT_RUNUP_COUNTRY_SUCCESS,
  failureType: EDIT_RUNUP_COUNTRY_FAILURE,
});

const getAreasSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/areas', ...action }),
  requestType: EDIT_RUNUP_AREA_REQUEST,
  successType: EDIT_RUNUP_AREA_SUCCESS,
  failureType: EDIT_RUNUP_AREA_FAILURE,
});

const getFirstMotionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/first-motions', ...action }),
  requestType: EDIT_RUNUP_FIRST_MOTION_REQUEST,
  successType: EDIT_RUNUP_FIRST_MOTION_SUCCESS,
  failureType: EDIT_RUNUP_FIRST_MOTION_FAILURE,
});

const getLocationSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/locations', ...action }),
  requestType: EDIT_RUNUP_LOCATION_REQUEST,
  successType: EDIT_RUNUP_LOCATION_SUCCESS,
  failureType: EDIT_RUNUP_LOCATION_FAILURE,
});

const getMeasureTypesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/measurement-types', ...action }),
  requestType: EDIT_RUNUP_MEASUREMENT_TYPE_REQUEST,
  successType: EDIT_RUNUP_MEASUREMENT_TYPE_SUCCESS,
  failureType: EDIT_RUNUP_MEASUREMENT_TYPE_FAILURE,
});

export const runupEditSagas = [
  getRunupSaga,
  createRunupSaga,
  updateRunupSaga,
  getTsunamiSaga,
  searchTsunamisSaga,
  getReferencesSaga,
  searchReferencesSaga,
  getRegionsSaga,
  getCountriesSaga,
  getAreasSaga,
  getFirstMotionsSaga,
  getLocationSaga,
  getMeasureTypesSaga,
];
